<template>
  <div class="notice-page">
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="搜索标题/内容" class="search" clearable />
      <el-button type="primary" @click="loadList">搜索</el-button>
      <el-button type="primary" @click="openCreate">新增公告</el-button>
    </div>
    <el-table :data="list" style="width:100%" stripe>
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="content" label="内容" />
      <el-table-column prop="date" label="日期" width="160">
        <template #default="{row}">
          <span>{{ row.date ? new Date(row.date * 1000).toLocaleDateString() : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"/>

    <el-dialog v-model="dialogVisible" title="公告信息" width="500px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="form.content" type="textarea" :rows="6" />
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="form.date" type="date" value-format="x" style="width:100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

const list = ref([])
const pagination = ref({ page: 1, pageSize: 30, total: 0 })
const keyword = ref('')
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({ id: null, title: '', content: '', date: '' })

const loadList = async () => {
  const params = { page: pagination.value.page, pageSize: pagination.value.pageSize, keyword: keyword.value }
  try {
    const data = await request.get('/v1/notice/list', { params })
    list.value = data.list
    pagination.value.total = data.pagination.total
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const pageChange = (p) => {
  pagination.value.page = p
  loadList()
}

const openCreate = () => {
  form.value = { id: null, title: '', content: '', date: '' }
  dialogVisible.value = true
}

const edit = async (row) => {
  try {
    const data = await request.get('/v1/notice/view', { params: { id: row.id } })
    form.value = { ...data }
    dialogVisible.value = true
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const submitForm = async () => {
  loading.value = true
  try {
    if (form.value.id) {
      await request.post('/v1/notice/update', { ...form.value })
      ElMessage.success('更新成功')
    } else {
      await request.post('/v1/notice/create', { ...form.value })
      ElMessage.success('创建成功')
    }
    dialogVisible.value = false
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    loading.value = false
  }
}

const remove = async (row) => {
  try {
    await request.post('/v1/notice/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

onMounted(loadList)
</script>

<style scoped>
.notice-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.search { width: 200px; }
.pager { margin-top: 15px; text-align: right; }
</style>
